if (!customElements.get('ahf-quick-links')) {
  customElements.define(
    'ahf-quick-links',
    class AhfQuickLinks extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.scope = this.closest('.shopify-section') || document;
        this.placeholder = document.createComment('ahf-quick-links');
        this.before(this.placeholder);
        this.mql = window.matchMedia('(max-width: 749px)');
        this.mql.addEventListener('change', () => this.place());
        this.place();
        this.addEventListener('click', (event) => {
          const chip = event.target.closest('.ahf-quick-links__chip');
          if (!chip) return;
          if (chip.dataset.media) this.showMedia(chip.dataset.media);
          if (chip.dataset.tab) this.openTab(chip.dataset.tab);
        });
      }

      place() {
        const gallery = this.scope.querySelector('media-gallery');
        if (this.mql.matches && gallery) {
          if (gallery.nextElementSibling !== this) gallery.after(this);
        } else if (this.placeholder.nextSibling !== this) {
          this.placeholder.after(this);
        }
        this.classList.toggle('ahf-quick-links--mobile', this.mql.matches && !!gallery);
      }

      showMedia(id) {
        const gallery = this.scope.querySelector('media-gallery');
        const media = gallery?.querySelector(`[id^="GalleryViewer"] [data-media-id$="-${id}"]`);
        if (!media) return;
        gallery.setActiveMedia(media.dataset.mediaId, false);
        this.scrollToElement(gallery);
      }

      openTab(name) {
        const details = [...this.scope.querySelectorAll('.product__accordion details')].find(
          (el) => el.querySelector('.accordion__title')?.textContent.trim().toLowerCase() === name
        );
        if (!details) return;
        details.open = true;
        this.scrollToElement(details);
      }

      scrollToElement(element) {
        const rect = element.getBoundingClientRect();
        if (rect.top >= 0 && rect.top < window.innerHeight * 0.5) return;
        const header = document.querySelector('.section-header');
        const offset = (header?.offsetHeight || 0) + 16;
        window.scrollTo({ top: rect.top + window.scrollY - offset, behavior: 'smooth' });
      }
    }
  );
}
